var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._v(" Model Nav: "+_vm._s(_vm.currParent)+" "),_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }